import { actionTypes } from "../actions/default.action"

const initialState = {
  affiliateaffiliateBillingPeriods: {
    data: [],
  },
  affiliateBillingPeriod: {},
  success: false,
  error: {},
}

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        affiliateBillingPeriods: {
          ...state.affiliateBillingPeriods,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        affiliateBillingPeriods: {
          ...state.affiliateBillingPeriods,
          data: state.affiliateBillingPeriods.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        affiliateBillingPeriod: {
          ...state.affiliateBillingPeriod,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
